import { ENV } from 'src/env';

// Branding settings
export const PRODUCT_TITLE = 'ZEISS Identity Management Portal';

// https://vitejs.dev/guide/env-and-mode
// eslint-disable-next-line no-restricted-syntax
export const IS_PROD = import.meta.env.PROD;

// System settings
export const BASE_PATH = ENV.VITE_MANAGEMENT_BASE_URL ?? '';
export const APP_CONFIG_URL = `${window.location.origin}${BASE_PATH}/config.json`;
export const APP_CONFIG_STORAGE_KEY = 'appConfig';

// i18n config
export const DEFAULT_LOCALE = 'en';

// Settings
export const DEFAULT_PAGE = 1;
export const DEBOUNCE_DELAY = 200;
export const MIN_CHARS_FOR_TENANT_NAME = 1;
export const MAX_CHARS_FOR_NAME = 60;
export const MAX_CHARS_FOR_TENANT_NAME = 200;
export const MIN_CHARS_FOR_SEARCH = 3;
export const RESPONSE_ITEMS_PER_PAGE = 1000;
export const SEARCH_ITEMS_PER_PAGE = 10;
export const TABLE_ITEMS_PER_PAGE = 25;

/**
 * Invitation app and tenant search limit
 *
 * Can be lowered once the FE supports cursor based pagination.
 */
export const INVITATIONS_SEARCH_LIMIT = 50;

export const INVITATION_EXPIRATION = 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds

// Validation pattern is based on Tenancy API documentation
export const NAME_PATTERN = /^([^\s][^]*[^\s]|[^\s]{1})$/;

// Fallback value for 'not available' values
export const NOT_AVAILABLE = '—';

export const DEFAULT_DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm';
